import { useMemo } from 'react';

import { isToolReleased, type Product } from '../utils/get-products';
import { useGlobalAppCtxSelector } from '../xstate/app.xstate';

/**
 * Drops tools whose feature flag is off.
 *
 * Filtering here rather than where the tool list is built, because the list is
 * computed once when projects finish loading while LaunchDarkly resolves
 * independently. A flag arriving after that never reached the list, so the
 * tool stayed hidden with the flag on. Reading it during render re-evaluates
 * whenever the flags change.
 */
export function useReleasedTools<T extends Pick<Product, 'name'>>(
  tools: T[] | undefined
): T[] {
  const featureFlags = useGlobalAppCtxSelector((ctx) => ctx.featureFlags);

  return useMemo(
    () =>
      (tools ?? []).filter(({ name }) => isToolReleased(name, featureFlags)),
    [tools, featureFlags]
  );
}
